import React, { useEffect } from 'react';

import { observer } from 'mobx-react';

import { OrderDetailsBlock } from './OrderDetailsBlock/OrderDetailsBlock';
import { CheckoutForm } from './CheckoutForm/CheckoutForm';
import { PaymentBlock } from '../../components/checkout/PaymentBlock/PaymentBlock';
import { angularizeWithProviders } from '../../../shared/providers';
import { getRouteParam } from '../../../shared/utils/angularUtils';
import { checkoutStore } from '../../stores/checkoutStore';
import { NgzPageNotFound } from '../../../shared/containers/NgzPageNotFound/NgzPageNotFound';
import { ScrollDownBadge } from '../../components/checkout/ScrollDownBadge/ScrollDownBadge';
import { SUBSCRIPTION } from '../../../shared/constants/user-info/subscription';
import { usePromoPriceLimited } from '../../hooks/usePromoPriceLimited';
import { CheckoutContainer } from '../../components/checkout/CheckoutContainer/CheckoutContainer';

const NgzCheckout = observer(() => {
  const { checkoutInfo, createSubscription, createScanIqSubscription, setDefaultValues } =
    checkoutStore;

  usePromoPriceLimited({
    promoPrice: checkoutInfo?.subscription.monthlyRenewalPricePromo,
    finalPrice: checkoutInfo?.subscription.monthlyRenewalPriceFinal,
  });

  const entityId = getRouteParam('entityId');
  const email = getRouteParam('email');
  const subscriptionId = getRouteParam('selectedSubscriptionId');
  const subscriptionType = getRouteParam('subscriptionType');

  if (!entityId || !subscriptionId || !subscriptionType) {
    return <NgzPageNotFound />;
  }

  useEffect(() => {
    if (subscriptionType === SUBSCRIPTION.SCAN_IQ) {
      createScanIqSubscription(entityId, subscriptionId);
    } else {
      createSubscription(entityId, email, subscriptionId);
    }

    return setDefaultValues;
  }, []);

  return (
    <CheckoutContainer>
      <OrderDetailsBlock />
      <ScrollDownBadge />
      <PaymentBlock paymentIntent={checkoutInfo?.paymentIntent}>
        <CheckoutForm />
      </PaymentBlock>
    </CheckoutContainer>
  );
});

angularizeWithProviders(NgzCheckout, 'ngzCheckout', {});
